<markdown
  [src]="'https://raw.githubusercontent.com/ZsZs/processpuzzle/refs/heads/develop/libs/js-shared/util/README.md'"
  (load)="onLoad($event)"
  (error)="onError($event)">
</markdown>
